import { render, staticRenderFns } from "./NewBrandMaintenance.vue?vue&type=template&id=ce0d56ca&"
import script from "./NewBrandMaintenance.vue?vue&type=script&lang=js&"
export * from "./NewBrandMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports